import { EvtccExam } from "@/data/evtccExams";
import { AseExam } from "@/data/aseExams";
import Card from "./ui/card";

interface LevelCardProps {
  title: string;
  evtExams: EvtccExam[];
  aseExams?: [string, AseExam][];
  evtLabel?: string;
  aseLabel?: string;
  className?: string;
}

export default function LevelCard({
  title,
  evtExams = [],
  aseExams = [],
  className = "",
}: LevelCardProps) {
  return (
    <Card className={className}>
      <h3 className="my-2">
        {title}
      </h3>
      {evtExams.length > 0 && (
        <>
          <h4 className="text-darkdarkred">
            ({evtExams.length}) EVTCC Exams
          </h4>
          <ul>
            {evtExams.map((exam, index) => (
              <li key={index} className="flex items-start text-left gap-2">
                <span className="font-bold shrink-0">{exam.code}:</span>
                <span>{exam.title}</span>
              </li>))}
          </ul>
        </>
      )}
      {aseExams.length > 0 && (
        <>
          <h4 className="text-darkdarkred">
            ({aseExams.length}) ASE Exams
          </h4>
          <ul>
            {aseExams.map((exam, index) => (
              <li key={index} className="flex items-start text-left gap-2">
                <span className="font-bold shrink-0">{exam[0]} {exam[1].code}:</span>
                <span>{exam[1].title}</span>
              </li>))}
          </ul>
        </>
      )}
    </Card >
  );
}
